import { CheckCircle2, AlertCircle } from "lucide-react";

export function FormAlert({ status }: { status: "success" | "error" }) {
  if (status === "success") {
    return (
      <div
        role="status"
        className="flex items-start gap-2.5 rounded-lg border border-status-success/30 bg-status-success/10 px-4 py-3 text-sm text-status-success"
      >
        <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0" />
        Thanks — your message has been sent. Our team will get back to you shortly.
      </div>
    );
  }
  return (
    <div
      role="alert"
      className="flex items-start gap-2.5 rounded-lg border border-status-error/30 bg-status-error/10 px-4 py-3 text-sm text-status-error"
    >
      <AlertCircle className="mt-0.5 h-4 w-4 flex-shrink-0" />
      Something went wrong sending your message. Please try again, or email us directly.
    </div>
  );
}
